"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnInfoPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const PopupPanel_1 = require("../Components/Popups/AdaptablePopup/PopupPanel");
const ColumnInfo_1 = require("./ColumnInfo");
const ColumnInfoPopup = (props) => {
    var _a, _b;
    return (React.createElement(PopupPanel_1.PopupPanel, { headerText: 'Column Info', glyphicon: 'info' },
        React.createElement(rebass_1.Flex, { flexDirection: "column", flex: 1, height: "100%" },
            React.createElement(ColumnInfo_1.ColumnInfo, { selectedColumnId: (_b = (_a = props.popupParams) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.columnId }))));
};
exports.ColumnInfoPopup = ColumnInfoPopup;
